import React from 'react';
import bn from '../utils/bemnames';
import { _t } from '../utils/translations';

interface IProps {
  text?: string;
}

const bem = bn.create('alert-no-data');

const AlertNoData: React.FC<IProps> = ({ text }) => (
  <div className={bem.e('wrapper')}>
    {text || _t('No data')}
  </div>
);

export default AlertNoData;
